import React from "react"
import { Spinner } from "react-bootstrap"

const LoadingSpinner = (props): JSX.Element => (
  <Spinner animation="border" role="status" {...props}>
    <span className="visually-hidden">Loading...</span>
  </Spinner>
)

export default LoadingSpinner
